import React from 'react';
import { motion } from 'framer-motion';
import { Box, Typography } from '@mui/material';
import { Construction, Architecture, Engineering, Business } from '@mui/icons-material';

const Preloader = () => {
    // Előre definiált pozíciók a háttér ikonoknak, hogy ne csússzanak egymásba
    const backgroundPositions = [...Array(20)].map((_, i) => {
        const section = Math.floor(i / 5); // 4 szekció, mindegyikben 5 ikon
        const positionInSection = i % 5;

        // Szekciónként különböző területekre osztjuk a képernyőt
        const xRange = section === 0 ? [0, 25] :
            section === 1 ? [25, 50] :
                section === 2 ? [50, 75] : [75, 100];

        // Az y pozíciót egyenletesen osztjuk el a szekción belül
        const yPos = (positionInSection * 20) + Math.random() * 10;
        const xPos = xRange[0] + Math.random() * (xRange[1] - xRange[0]);

        return { x: xPos, y: yPos };
    });

    return (
        <motion.div
            initial={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: 'linear-gradient(135deg, #2c5049 0%, #1a2421 100%)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999,
                overflow: 'hidden'
            }}
        >
            {/* Háttér elemek */}
            <motion.div
                style={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    overflow: 'hidden'
                }}
            >
                {backgroundPositions.map((pos, i) => (
                    <motion.div
                        key={i}
                        style={{
                            position: 'absolute',
                            left: `${pos.x}%`,
                            top: `${pos.y}%`,
                            opacity: 0.1,
                            transform: `rotate(${Math.random() * 360}deg)`,
                            padding: '1rem'
                        }}
                        animate={{
                            y: [0, -10, 0],
                            opacity: [0.08, 0.15, 0.08],
                            rotate: [`${Math.random() * 360}deg`, `${Math.random() * 360 + 180}deg`]
                        }}
                        transition={{
                            duration: 3 + Math.random() * 2,
                            repeat: Infinity,
                            delay: Math.random() * 2,
                            ease: "linear"
                        }}
                    >
                        {i % 4 === 0 && <Construction style={{ fontSize: 35, color: '#fff' }} />}
                        {i % 4 === 1 && <Architecture style={{ fontSize: 32, color: '#fff' }} />}
                        {i % 4 === 2 && <Engineering style={{ fontSize: 30, color: '#fff' }} />}
                        {i % 4 === 3 && <Business style={{ fontSize: 28, color: '#fff' }} />}
                    </motion.div>
                ))}
            </motion.div>

            {/* Központi logó és szöveg */}
            <motion.div
                animate={{
                    scale: [1, 1.1, 1],
                    rotate: [0, 360],
                }}
                transition={{
                    duration: 3,
                    repeat: Infinity,
                    ease: "easeInOut"
                }}
                style={{
                    background: 'rgba(255, 255, 255, 0.1)',
                    borderRadius: '50%',
                    padding: '2.5rem',
                    boxShadow: '0 0 40px rgba(255, 255, 255, 0.1)',
                    marginBottom: '2rem'
                }}
            >
                <Construction style={{ fontSize: 90, color: '#ffa726' }} />
            </motion.div>

            <Box sx={{ textAlign: 'center', position: 'relative', zIndex: 2 }}>
                <motion.div
                    animate={{
                        opacity: [0.8, 1, 0.8],
                    }}
                    transition={{
                        duration: 2,
                        repeat: Infinity,
                        ease: "easeInOut"
                    }}
                >
                    <Typography
                        variant="h3"
                        style={{
                            color: '#fff',
                            fontWeight: 600,
                            letterSpacing: '3px',
                            textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                            marginBottom: '1rem'
                        }}
                    >
                        Toronyszerver KFT
                    </Typography>
                    <Typography
                        variant="h6"
                        style={{
                            color: '#ffa726',
                            letterSpacing: '2px',
                            textTransform: 'uppercase',
                            fontWeight: 500
                        }}
                    >
                        Ipari Építőipari Kivitelezés
                    </Typography>
                </motion.div>
            </Box>

            {/* Betöltő sáv */}
            <Box sx={{ mt: 5, width: '250px', position: 'relative', zIndex: 2 }}>
                <motion.div
                    style={{
                        width: '100%',
                        height: '4px',
                        background: 'rgba(255, 255, 255, 0.15)',
                        borderRadius: '2px',
                        overflow: 'hidden',
                        boxShadow: '0 0 10px rgba(255, 167, 38, 0.3)'
                    }}
                >
                    <motion.div
                        style={{
                            width: '40%',
                            height: '100%',
                            background: 'linear-gradient(90deg, #ffa726 0%, #ffb74d 100%)',
                            borderRadius: '2px'
                        }}
                        animate={{
                            x: [-250, 250],
                        }}
                        transition={{
                            duration: 2,
                            repeat: Infinity,
                            ease: "easeInOut"
                        }}
                    />
                </motion.div>
            </Box>
        </motion.div>
    );
};

export default Preloader; 